import React, { memo } from 'react'
import Sl1 from '../../../img/pd1.jpg'
import Sl2 from '../../../img/pd2.jpg'
import Sl3 from '../../../img/pd3.jpg'

function Product() {
  return (
    <div className="products">
      <div className="slide-products">
        <ImageSlider img={Sl1} />
        <ImageSlider img={Sl2} />
        <ImageSlider img={Sl3} />
      </div>
    </div>
  )
}

export default memo(Product)

const ImageSlider = ({ img }: { img: string }) => {
  return (
    <div className="card-slider">
      <div className="crd-l">
        <h1>Most favoutire collections</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit.
          <br /> Illo quod id deleniti.
        </p>
      </div>
      <div className="crd-r">
        <img src={img} alt="slider" />
      </div>
    </div>
  )
}
